<template>
    <div id='chart-Tooltip'>
      <component v-if='hasData' :style='style' :is='type' :contents='tooltipData' :currency='currency'></component>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus'
export default {
  data() {
    return {
      style: null,
      type: null,
      tooltipData: [],
      currency: 'USD',
      hasData: false
    }
  },
  created() {
    EventBus.$on('showChartTooltip', r => {
      this.style = r.data.style
      this.tooltipData = r.data.tooltipData
      this.currency = r.data.currency
      this.type = r.data.type
      this.hasData = r.data.hasData
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/core/charts/components/chart-tooltip.vue